// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import ApartmentIcon from '@mui/icons-material/Apartment';
import moment from 'moment';

import {
  CONFIG_ROUTES,
  CONFIG_URLS,
  getCurrentLanguageCode,
} from 'app/configuration/configuration-api';

const FareMediaIssuerOrganizationsTable: React.FC = () => {
  const currentLanguageCode = getCurrentLanguageCode();
  const isEnglish = currentLanguageCode === 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="FareMediaIssuerOrganizations"
      pageIcon={ApartmentIcon}
      addButtonLabel="AddNewFareMediaIssuerOrganization"

      // ============ NAVIGATION URLs ============
      addPageUrl={`${CONFIG_ROUTES.fareMediaIssuerOrganisations}/new`}
      viewPageUrl={`${CONFIG_ROUTES.fareMediaIssuerOrganisations}/:id`}
      editPageUrl={`${CONFIG_ROUTES.fareMediaIssuerOrganisations}/:id/edit?came_from=all`}

      // ============ API CONFIGURATION ============
      // A non-super-admin only ever receives their own organisation's rows —
      // the scope is applied server-side, not by a filter here.
      getApiUrl={CONFIG_URLS.fareMediaIssuerOrganisations}
      getApiMethod="GET"

      // Hard DELETE — no soft-delete column. fare_media references this table
      // ON DELETE RESTRICT, so the API answers a translated 409 when cards were
      // issued under the assignment, and EntityTable shows it in a toast.
      deleteApiUrl={CONFIG_URLS.fareMediaIssuerOrganisationById}
      deleteApiMethod="DELETE"

      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.fareMediaIssuerOrganisations"
      responsePaginationPath="data.data.pagination"

      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'en_issuer_name',
          headerKey: 'FareMediaIssuer',
          align: 'center',
          render: (value, row) => (isEnglish ? row.en_issuer_name : row.ar_issuer_name) || '-',
          sortable: true,
          sortField: isEnglish ? 't.en_issuer_name' : 't.ar_issuer_name',
        },
        {
          field: 'org_en_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => (isEnglish ? row.org_en_name : row.org_ar_name) || '-',
          sortable: true,
          sortField: isEnglish ? 't.org_en_name' : 't.org_ar_name',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: value => (value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'),
          sortable: true,
          sortField: 't.created_at',
        },
      ]}

      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchFareMediaIssuerOrganizationPlaceholder"
      searchInputWidth="360px"

      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'fare_media_issuer_id',
          labelKey: 'FareMediaIssuer',
          type: 'dropdown',
          apiUrl: CONFIG_URLS.fareMediaIssuersLookup,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) =>
              isEnglish ? item.en_issuer_name : item.ar_issuer_name,
          },
        },
        {
          name: 'organisation_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: CONFIG_URLS.organisations,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => (isEnglish ? item.en_name : item.ar_name),
          },
        },
      ]}

      // ============ PERMISSIONS ============
      subsystemName="FareMediaIssuersOrganisations"
      permissionSystem="masterConfig"

      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteFareMediaIssuerOrganization"
    />
  );
};

export default FareMediaIssuerOrganizationsTable;
